import React, { useEffect, useState } from "react";
import { initialFormData, useForm } from "../context/Form/FormContext";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import SpinnerModal from "../../Utils/Spinner/Spinner";
import swal from "sweetalert";
import StyledLabel from "../Label/StyledLabel";
import { useToast } from "../context/ToastContext";
import { AutoCompleteClient } from "../AutoComplete/AutoCompleteClient";
import { AutoCompleteProduct } from "../AutoComplete/AutoCompleteProduct";
import { jwtDecode } from "jwt-decode";
import Cleave from "cleave.js/react";
import { FaSearchIcon } from "../../pages/OCRPage";
import { checkJourneyExists } from "../../services/journeyService";
import { formatPhone } from "../../Utils/formatPhone";

const ConsultCpfForm: React.FC = () => {
    const { formData, setFormData } = useForm();
    const showToast = useToast();

    const [showLinkModal, setShowLinkModal] = useState(false);
    const [generatedLink, setGeneratedLink] = useState<string | null>(null);

    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const [showSelectModal, setShowSelectModal] = useState(false);

    const [clientName, setClientName] = useState("");
    const [selectedClient, setSelectedClient] = useState<any | null>(null);
    const [productName, setProductName] = useState("");
    const [selectedProduct, setSelectedProduct] = useState<any | null>(null);

    const [protocol, setProtocol] = useState("");
    const [isApto, setIsApto] = useState<string | null>(null);
    const [creditCardLimit, setCreditCardLimit] = useState<string | null>(null);
    const [reasonRejected, setReasonrejected] = useState<string | null>(null);
    const [mensagemAtencao, setMensagemAtencao] = useState<string | null>(null);

    const [isAptoPartners, setIsAptoPartners] = useState<any | null>(null);

    // Verificação de telefone
    const [loadingPhone, setLoadingPhone] = useState(false);
    const [phoneChecked, setPhoneChecked] = useState(false);
    const [hotlineResults, setHotlineResults] = useState<{ [cpf: string]: string }>({});
    const [phoneWarnings, setPhoneWarnings] = useState<string[]>([]);

    const [cpfFields, setCpfFields] = useState({
        cpf: "",
        name: "",
        email: "",
        telefone: "",
    });

    let objUserTk: any;
    if (localStorage.getItem("token")) {
        objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
    } else {
        objUserTk = {};
    }

    const FRONT_BASE_URL = "https://portaldemo.4axon.tec.br".replace(/\/+$/, "");

    function toFullLink(link: string) {
        if (!link) return "";
        if (/^https?:\/\//i.test(link)) return link;
        return `${FRONT_BASE_URL}${link.startsWith("/") ? "" : "/"}${link}`;
    }

    const isMasterOrComum = objUserTk.Rule === "Master" || objUserTk.Rule === "Comum";

    const normalizePhone = (tel: string | undefined) => (tel ?? "").replace(/\D/g, "");

    const handleSubmitStep1 = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!formData.document) {
            showToast("info", "Preencha o CPF");
            return;
        }
        if (!formData.productId) {
            showToast("info", "Selecione um produto");
            return;
        }

        setLoading(true);

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const formDataReq = new FormData();
            if (file) formDataReq.append("file", file);

            formDataReq.append("idProduct", String(formData.productId));
            formDataReq.append("cnpj", formData.document);
            formDataReq.append("idClient", objUserTk.IdClient);

            const response = await axios.post(`${apiUrl}/N8N/uploadDocument`, formDataReq, {
                headers: { Authorization: objUserTk.token, Appkey: objUserTk.Appkey },
            });

            if (response.data) {
                const dataJson = JSON.parse(response.data.json);

                setIsApto(response.data.apto?.dados?.recommendation);
                setCreditCardLimit(response.data.apto?.dados?.creditCardLimit);
                setReasonrejected(response.data.apto?.dados?.reasonForFailing);
                setMensagemAtencao(dataJson.mensagem ?? null);
                setProtocol(response.data.apto?.protocolo ?? "");
            }
        } catch (err: any) {
            console.error(err);
            if (axios.isAxiosError(err) && err.response) {
                const apiError = {
                    instance: err.response.data.instance,
                    status: err.response.status,
                    title: err.response.data.title,
                    errors: err.response.data,
                };
                swal({
                    title: "Falha na requisição",
                    text: JSON.stringify(apiError.errors, null, 2),
                    icon: "error",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleBeforeSubmitStep2 = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setShowSelectModal(true);
    };

    const handleSubmitCpf = async (useJourney: boolean) => {
        setLoading(true);
        try {
            const clientId = selectedClient?.id ?? objUserTk?.IdClient;

            if (useJourney) {
                const hasJourney = await checkJourneyExists(clientId, Number(formData.productId));
                if (!hasJourney) {
                    showToast("info", "Nenhuma jornada configurada para este cliente e produto.");
                    setLoading(false);
                    return;
                }
            }

            const apiUrl = process.env.REACT_APP_API_URL;
            const payload = {
                Signatories: [
                    {
                        Cpf: cpfFields.cpf,
                        Name: cpfFields.name,
                        Email: cpfFields.email,
                        Phone: cpfFields.telefone,
                        RepresentanteLegal: false,
                    },
                ],
                Protocolo: protocol,
                IdProduct: formData.productId,
                TypeJourney: useJourney,
            };

            const { data } = await axios.post(`${apiUrl}/Orchestrator/analyzePartners`, payload, {
                headers: { Authorization: objUserTk.token, Appkey: objUserTk.Appkey },
            });

            if (data) setIsAptoPartners(data.dados);
        } catch (err: any) {
            console.error(err);
            if (axios.isAxiosError(err) && err.response) {
                const apiError = {
                    instance: err.response.data.instance,
                    status: err.response.status,
                    title: err.response.data.title,
                    errors: err.response.data,
                };
                swal({
                    title: "Falha na requisição",
                    text: JSON.stringify(apiError.errors, null, 2),
                    icon: "error",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyPhone = async () => {
        setLoadingPhone(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            const payload = [
                {
                    document: cpfFields.cpf,
                    protocol: protocol,
                    telephone: cpfFields.telefone,
                },
            ];

            const { data } = await axios.post(`${apiUrl}/Serasa/verifyid`, payload, {
                headers: {
                    Authorization: objUserTk.token,
                    Appkey: objUserTk.Appkey,
                    "Content-Type": "application/json",
                },
            });

            const warnings: string[] = [];
            const hotlineObj = data.reduce((acc: any, item: any) => {
                const hotline = item.distinct;
                const informedPhone = cpfFields.telefone;

                if (
                    hotline !== "Não encontrado" &&
                    informedPhone &&
                    normalizePhone(hotline) !== normalizePhone(informedPhone)
                ) {
                    warnings.push(
                        `Telefone informado ${informedPhone} para CPF ${item.cpf} diferente do Hotline ${formatPhone(hotline)}.`
                    );
                }

                if (hotline !== "Não encontrado") {
                    acc[item.cpf] = hotline;
                } else if (!acc[item.cpf]) {
                    acc[item.cpf] = "Não encontrado";
                }
                return acc;
            }, {});

            setHotlineResults(hotlineObj);
            setPhoneWarnings(warnings);
            setPhoneChecked(true);
        } catch (err) {
            console.error("Erro ao verificar telefone", err);
            swal({
                title: "Erro na verificação do telefone",
                text: "Não foi possível concluir a análise do telefone.",
                icon: "error",
            });
        } finally {
            setLoadingPhone(false);
        }
    };

    const handleCpfFieldsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setCpfFields((prev) => ({ ...prev, [name]: value }));
        if (name === "cpf") {
            setFormData((prev: any) => ({ ...prev, document: value }));
        }
    };

    function handleProductTyping(text: string) {
        setProductName(text);
    }

    function handleProductSelect(prod: any) {
        setProductName(prod.description);
        setSelectedProduct(prod);
        setFormData((prev) => ({ ...prev, productId: prod.id }));
    }

    const clearFields = () => {
        setProtocol("");
        setClientName("");
        setSelectedClient(null);
        setProductName("");
        setSelectedProduct(null);
        setIsApto(null);
        setCreditCardLimit(null);
        setReasonrejected(null);
        setIsAptoPartners(null);
        setMensagemAtencao(null);
        setFile(null);
        setFormData(initialFormData);
        setPhoneWarnings([]);
        setPhoneChecked(false);
        setHotlineResults({});
        setCpfFields({ cpf: "", name: "", email: "", telefone: "" });
    };

    useEffect(() => {
        if (isApto === "Apto") {
            setFormData((prev: any) => ({
                ...prev,
                signatories: [{
                    cpf: (cpfFields.cpf ?? "").trim(),
                    name: (cpfFields.name ?? "").trim(),
                    email: (cpfFields.email ?? "").trim(),
                    telefone: (cpfFields.telefone ?? "").trim(),
                    representanteLegal: true
                }]
            }));
        }
    }, [isApto, cpfFields.cpf, cpfFields.name, cpfFields.email, cpfFields.telefone, setFormData]);

    type DeliveryMode = "sms" | "whatsapp" | "screen";

    const handleSubmitSignatarios = async (mode: DeliveryMode) => {
        setLoading(true);

        try {
            const clientId = selectedClient?.id ?? objUserTk?.IdClient;
            const productId = formData.productId;

            const wantsJourney = mode !== "sms";
            if (wantsJourney) {
                const hasJourney = await checkJourneyExists(clientId, Number(productId));
                if (!hasJourney) {
                    showToast("info", "Nenhuma jornada configurada para este cliente e produto.");
                    setLoading(false);
                    return;
                }
            }

            const apiUrl = process.env.REACT_APP_API_URL;

            const sCpf = (cpfFields.cpf ?? "").trim();
            const sName = (cpfFields.name ?? "").trim();
            const sEmail = (cpfFields.email ?? "").trim();
            const sPhone = (cpfFields.telefone ?? "").trim();

            if (!sCpf || !sName) {
                showToast("info", "Preencha CPF e Nome antes de continuar.");
                setLoading(false);
                return;
            }

            const signatoriesPayload = [{
                Cpf: sCpf,
                Name: sName,
                Email: sEmail,
                Phone: sPhone,
                RepresentanteLegal: true
            }];

            const typeJourney =
                mode === "whatsapp" ? true :
                    mode === "sms" ? false :
                        null;

            const payload: any = {
                Signatories: signatoriesPayload,
                Protocolo: protocol,
                IdProduct: formData.productId,
                DeliveryMode: mode,
                ...(typeJourney !== null ? { TypeJourney: typeJourney } : {}),
            };

            const response = await axios.post(`${apiUrl}/Orchestrator/analyzePartners`, payload, {
                headers: { Authorization: objUserTk.token, Appkey: objUserTk.Appkey },
            });

            if (response.data) {
                setIsAptoPartners(response.data.dados);

                if (mode === "screen") {
                    const link =
                        response.data?.link ??
                        response.data?.url ??
                        response.data?.dados?.link ??
                        response.data?.dados?.url ??
                        null;

                    if (link) {
                        const fullLink = toFullLink(link);

                        setGeneratedLink(fullLink);
                        setShowLinkModal(true);
                    } else {
                        showToast("warning", "A API não retornou um link para exibir na tela.");
                    }
                }
            }
            if (response.data) {
                setIsAptoPartners(response.data.dados);

                if (mode === "screen") {
                    const link =
                        response.data?.link ??
                        response.data?.url ??
                        response.data?.dados?.link ??
                        response.data?.dados?.url ??
                        null;

                    if (link) {
                        const fullLink = toFullLink(link);

                        setGeneratedLink(fullLink);
                        setShowLinkModal(true);
                    } else {
                        showToast("warning", "A API não retornou um link para exibir na tela.");
                    }
                }
            }
        } catch (err) {
            setLoading(false);
            console.log(err, "error");
            if (axios.isAxiosError(err) && err.response) {
                const apiError = {
                    instance: err.response.data.instance,
                    status: err.response.status,
                    title: err.response.data.title,
                    errors: err.response.data,
                };
                swal({
                    title: "Falha na requisição",
                    text: JSON.stringify(apiError.errors, null, 2),
                    icon: "error",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <form onSubmit={isApto === "Apto" ? handleBeforeSubmitStep2 : handleSubmitStep1}>
                <label htmlFor="fileInput" style={{ display: "block", fontWeight: 600, marginBottom: 8 }}>
                    Selecione ou arraste o documento:
                </label>
                <div
                    onClick={() => document.getElementById("fileInput")?.click()}
                    style={{
                        border: "2px dashed #78E01D",
                        borderRadius: 12,
                        padding: 20,
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: "#f9f9f9",
                        color: "#666",
                        marginBottom: 16,
                        transition: "all 0.3s ease",
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        if (e.dataTransfer.files && e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]);
                    }}
                >
                    <FaSearchIcon style={{ color: "#78E01D", marginBottom: 8 }} />
                    <p style={{ margin: 0 }}>
                        {file ? <strong style={{ color: "#333" }}>{file.name}</strong> : "Clique ou arraste um arquivo aqui"}
                    </p>
                    <small style={{ color: "#999" }}>(PDF)</small>
                </div>
                <input
                    id="fileInput"
                    type="file"
                    accept=".pdf"
                    onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                            setFile(e.target.files[0]);
                            e.target.value = "";
                        }
                    }}
                    style={{ display: "none" }}
                />

                <div className="row">
                    <div className="col-md-4 form-group">
                        {objUserTk.Rule === "Master4Axon" && (
                            <AutoCompleteClient
                                label="Cliente:"
                                value={clientName}
                                onChange={(v) => {
                                    setClientName(v);
                                    setSelectedClient(null);
                                }}
                                onSelect={(cli) => {
                                    setClientName(cli.corporateName);
                                    setSelectedClient(cli);
                                    setProductName("");
                                    setSelectedProduct(null);
                                }}
                            />
                        )}
                    </div>

                    <div className="col-md-4 form-group">
                        <AutoCompleteProduct
                            label="Produto:*"
                            clientId={selectedClient?.id ?? (isMasterOrComum ? objUserTk.IdClient : null)}
                            value={productName}
                            onChange={handleProductTyping}
                            onSelect={handleProductSelect}
                        />
                    </div>

                    <div className="col-md-4 form-group">
                        <StyledLabel>CPF:*</StyledLabel>
                        <Cleave
                            key="cpf-mask"
                            options={{ delimiters: [".", ".", "-"], blocks: [3, 3, 3, 2], numericOnly: true }}
                            name="document"
                            value={formData.document}
                            onChange={(e: any) => {
                                setFormData((prev: any) => ({ ...prev, document: e.target.value }));
                                setCpfFields((prev) => ({ ...prev, cpf: e.target.value }));
                            }}
                            className="form-control"
                            style={{ borderRadius: 15, padding: 10 }}
                        />
                    </div>
                </div>

                {isApto && (
                    <div
                        className="mt-4 p-3 d-flex justify-content-between align-items-center"
                        style={{
                            backgroundColor: isApto === "Apto" ? "#d4edda" : "#f8d7da",
                            border: `1px solid ${isApto === "Apto" ? "#c3e6cb" : "#f5c6cb"}`,
                            color: isApto === "Apto" ? "#155724" : "#721c24",
                            borderRadius: 8,
                            fontWeight: "bold",
                        }}
                    >
                        <span>
                            {isApto === "Apto"
                                ? "CPF apto para continuar a análise!"
                                : `CPF não apto. Fluxo encerrado. Razão: ${reasonRejected}`}
                        </span>
                        <span style={{ marginLeft: "auto" }}>
                            Limite Aprovado: R${" "}
                            {creditCardLimit
                                ? Number(creditCardLimit).toLocaleString("pt-BR", { minimumFractionDigits: 2 })
                                : "0,00"}
                        </span>
                    </div>
                )}

                {mensagemAtencao && (
                    <div
                        className="mt-3 p-3"
                        style={{
                            backgroundColor: "#fff3cd",
                            border: "1px solid #ffeeba",
                            color: "#856404",
                            borderRadius: 8,
                            fontWeight: "bold",
                        }}
                    >
                        {mensagemAtencao}
                    </div>
                )}

                {isApto === "Apto" && (
                    <div className="border rounded p-3 mb-4 mt-3" style={{ backgroundColor: "#f9f9f9" }}>
                        <div className="row">
                            <div className="col-md-3 form-group">
                                <StyledLabel>Nome:*</StyledLabel>
                                <input
                                    style={{ borderRadius: 15, padding: 10 }}
                                    className="form-control"
                                    type="text"
                                    name="name"
                                    value={cpfFields.name}
                                    onChange={handleCpfFieldsChange}
                                />
                            </div>

                            <div className="col-md-3 form-group">
                                <StyledLabel>E-mail:</StyledLabel>
                                <input
                                    style={{ borderRadius: 15, padding: 10 }}
                                    className="form-control"
                                    type="email"
                                    name="email"
                                    value={cpfFields.email}
                                    onChange={handleCpfFieldsChange}
                                />
                            </div>

                            <div className="col-md-3 form-group">
                                <StyledLabel>Telefone:</StyledLabel>
                                <Cleave
                                    options={{ delimiters: ["(", ")", " ", "-", ""], blocks: [0, 2, 5, 4], numericOnly: true }}
                                    style={{ borderRadius: 15, padding: 10 }}
                                    className="form-control"
                                    type="text"
                                    name="telefone"
                                    value={cpfFields.telefone}
                                    onChange={handleCpfFieldsChange}
                                />
                            </div>

                            <div className="col-md-3 form-group">
                                <StyledLabel>Hotline Bureau:</StyledLabel>
                                <input
                                    style={{ borderRadius: 15, padding: 10 }}
                                    className="form-control"
                                    type="text"
                                    value={formatPhone(hotlineResults?.[cpfFields.cpf]) || ""}
                                    disabled
                                />
                            </div>
                        </div>

                        {phoneWarnings.length > 0 && (
                            <small className="text-warning d-flex align-items-center gap-1 mt-2">
                                <i className="bi bi-exclamation-triangle-fill" /> {phoneWarnings[0]}
                            </small>
                        )}
                    </div>
                )}

                <div className="row mt-4">
                    <div className="d-flex justify-content-between">
                        <Button
                            onClick={clearFields}
                            style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", marginTop: 10 }}
                        >
                            Limpar
                        </Button>

                        <div>
                            {isApto === "Apto" && (
                                <Button
                                    type="button"
                                    variant="primary"
                                    disabled={loadingPhone}
                                    style={{ backgroundColor: "#1D9EE0", borderColor: "#1D9EE0", fontWeight: 500, marginRight: 10 }}
                                    onClick={handleVerifyPhone}
                                >
                                    {loadingPhone ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Analisando Telefone...
                                        </>
                                    ) : (
                                        "Analisar Telefone"
                                    )}
                                </Button>
                            )}

                            <Button
                                type="submit"
                                variant="primary"
                                disabled={loading || (isApto === "Apto" && !phoneChecked)}
                                style={{ backgroundColor: "#78E01D", borderColor: "#78E01D", fontWeight: 500 }}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        {isApto === "Apto" ? "Analisando CPF..." : "Analisando CPF..."}
                                    </>
                                ) : isApto === "Apto" ? (
                                    "Analisar CPF"
                                ) : (
                                    "Analisar CPF"
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </form>

            <Modal show={showSelectModal} onHide={() => setShowSelectModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold fs-5">⚙️ Forma de envio do link</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="text-muted text-center mb-4">
                        Como você deseja realizar a análise dos sócios?
                    </p>

                    <div className="d-flex flex-column gap-3">
                        <Button
                            variant="outline-primary"
                            size="lg"
                            className="fw-semibold w-100"
                            onClick={() => {
                                setShowSelectModal(false);
                                handleSubmitSignatarios("sms");
                            }}
                        >
                            🔍 Receber por SMS
                        </Button>

                        <Button
                            variant="success"
                            size="lg"
                            className="fw-semibold w-100"
                            onClick={() => {
                                setShowSelectModal(false);
                                handleSubmitSignatarios("whatsapp");
                            }}
                        >
                            🚀 Receber por WhatsApp
                        </Button>

                        <Button
                            variant="secondary"
                            size="lg"
                            className="fw-semibold w-100"
                            onClick={() => {
                                setShowSelectModal(false);
                                handleSubmitSignatarios("screen");
                            }}
                        >
                            🔗 Mostrar link na tela
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showLinkModal} onHide={() => setShowLinkModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold fs-5">Link de verificação</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {generatedLink ? (
                        <div className="d-flex flex-column gap-3">
                            <div className="input-group">
                                <input
                                    className="form-control"
                                    value={generatedLink}
                                    readOnly
                                    style={{ borderRadius: 10 }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => {
                                        try {
                                            navigator?.clipboard?.writeText(generatedLink);
                                        } catch {
                                        }
                                    }}
                                >
                                    Copiar
                                </button>
                                <a
                                    className="btn btn-success"
                                    href={generatedLink}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Abrir
                                </a>
                            </div>
                            <small className="text-muted">
                                O link acima é válido para a verificação manual.
                            </small>
                        </div>
                    ) : (
                        <p className="text-muted mb-0">Nenhum link retornado pela API.</p>
                    )}
                </Modal.Body>
            </Modal>

            {isAptoPartners && (
                <div
                    className="mt-4 p-3"
                    style={{
                        backgroundColor:
                            (isAptoPartners === "Apto" ||
                                isAptoPartners?.recommendation === "Apto" ||
                                isAptoPartners?.recommendation === "Processando")
                                ? "#d4edda"
                                : "#f8d7da",
                        border: `1px solid ${(isAptoPartners === "Apto" ||
                            isAptoPartners?.recommendation === "Apto" ||
                            isAptoPartners?.recommendation === "Processando")
                            ? "#c3e6cb"
                            : "#f5c6cb"}`,
                        color:
                            (isAptoPartners === "Apto" ||
                                isAptoPartners?.recommendation === "Apto" ||
                                isAptoPartners?.recommendation === "Processando")
                                ? "#155724"
                                : "#721c24",
                        borderRadius: 8,
                        fontWeight: "bold",
                    }}
                >
                    {isAptoPartners === "Apto" || isAptoPartners?.recommendation === "Apto"
                        ? "CPF Apto!"
                        : isAptoPartners?.recommendation === "Processando"
                            ? "Link de verificação enviado!"
                            : "CPF Não Apto!"}
                </div>
            )}
        </div>
    );
};

export default ConsultCpfForm;